export class ModalRenderListener {
    public static bindYouTubePreviewClick(modalBody: HTMLElement, onClick: (event: Event) => void): void {
        modalBody.addEventListener("click", onClick, true);
    }
}
